import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { CarouselConfig } from 'ngx-bootstrap/carousel';
import { Banner } from 'src/app/core/models/banner';

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  providers: [
    { provide: CarouselConfig, useValue: { interval: 5000, noPause: false, showIndicators: true } }
  ],
  styleUrls: ['./carousel.component.scss'],

})
export class CarouselComponent implements OnInit {

  slides: Banner[];

  /*slides = [
    //{ image: './assets/img/banner/banner-1.jpg', text: '¡Ya estrenamos!', title: 'Nuestro portal de siempre ahora con una nueva imagen'  },
    { image: './assets/img/banner/banner-1.png', text: 'Pedidos', title: '¡Participa por el sorteo de 1 de las 4 tablets!'  },
    { image: './assets/img/banner/banner-2.jpg', text: 'Horario hábil', title:  'Planifica tus operaciones en un solo lugar entre las 06:30am y 02:30am' },
    { image: './assets/img/banner/banner-3.jpg', text: 'Nuevo Enex Directo', title: 'Realiza tus pedidos y pagos en línea a través de nuestro Portal Enex Directo' }
  ];*/

  noWrapSlides = false;
  showIndicator = true;
  constructor(private http: HttpClient) { }

  ngOnInit(): void {
    this.getBannerData();
  }  
  
  getBannerData() {
    this.http.get<Banner[]>('./assets/img/banner/banners.json').subscribe(data => {
      this.slides = data;
      console.log(this.slides);
      return this.slides;
    });
  }
}
